/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable comma-style */
/* eslint-disable no-undef */
import { ComScoreWeb } from './comscore';

const props = [];

export const ComScoreWebDirective = (reactDirective) => reactDirective(ComScoreWeb, props);
ComScoreWebDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('comScoreWeb', ComScoreWebDirective);
